export interface Coupon {
  id: string
  code: string
  name: string
  description?: string
  discountType: 'percentage' | 'fixed'
  discountValue: number
  affiliateId?: string
  maxUses?: number
  maxUsesPerUser: number
  currentUses: number
  minimumPurchase: number
  validFrom?: string
  validUntil?: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface CouponValidationResult {
  valid: boolean
  discountAmount: number
  finalPrice: number
  coupon?: Coupon
  errorCode?: string
  errorMessage?: string
}

export interface ValidateCouponRequest {
  code: string
  originalPrice: number
}

export interface ApplyCouponRequest {
  couponId: string
  enrollmentId: string
  discountAmount: number
}

// Error codes returned by the backend
export type CouponErrorCode =
  | 'COUPON_NOT_FOUND'
  | 'COUPON_INACTIVE'
  | 'COUPON_EXPIRED'
  | 'COUPON_NOT_YET_VALID'
  | 'COUPON_MAX_USES_REACHED'
  | 'COUPON_USER_MAX_USES_REACHED'
  | 'COUPON_MINIMUM_NOT_MET'

export function getCouponErrorMessage(errorCode: CouponErrorCode | string): string {
  switch (errorCode) {
    case 'COUPON_NOT_FOUND':
      return 'Kode kupon tidak ditemukan'
    case 'COUPON_INACTIVE':
      return 'Kupon ini sudah tidak aktif'
    case 'COUPON_EXPIRED':
      return 'Kupon ini sudah kedaluwarsa'
    case 'COUPON_NOT_YET_VALID':
      return 'Kupon ini belum berlaku'
    case 'COUPON_MAX_USES_REACHED':
      return 'Kupon ini sudah mencapai batas penggunaan'
    case 'COUPON_USER_MAX_USES_REACHED':
      return 'Anda sudah mencapai batas penggunaan kupon ini'
    case 'COUPON_MINIMUM_NOT_MET':
      return 'Total pembelian tidak memenuhi minimum untuk kupon ini'
    default:
      return 'Kupon tidak valid'
  }
}

export interface CouponUsage {
  id: string
  couponId: string
  userId: string
  enrollmentId: string
  discountAmount: number
  usedAt: string
  userName?: string
  userEmail?: string
  courseName?: string
}

export interface CreateCouponInput {
  code: string
  name: string
  description?: string
  discount_type: 'percentage' | 'fixed'
  discount_value: number
  max_uses?: number
  max_uses_per_user?: number
  minimum_purchase?: number
  valid_from?: string
  valid_until?: string
}

export interface UpdateCouponInput {
  name?: string
  description?: string
  discount_type?: 'percentage' | 'fixed'
  discount_value?: number
  max_uses?: number
  max_uses_per_user?: number
  minimum_purchase?: number
  valid_from?: string
  valid_until?: string
  is_active?: boolean
}

export function formatDiscount(coupon: Coupon): string {
  if (coupon.discountType === 'percentage') {
    return `${coupon.discountValue}%`
  }
  return `Rp ${coupon.discountValue.toLocaleString('id-ID')}`
}
